import React from 'react';
import { motion } from 'framer-motion';
import { FileText, ListChecks, Activity, Thermometer, Moon, Clock, CheckSquare } from 'lucide-react';
export function WhatIncluded() {
  const items = [{
    icon: Activity,
    text: 'Test rápido para identificar tu Perfil de Despertar'
  }, {
    icon: Map,
    text: 'El Mapa 3AM (5 escenarios detallados)'
  }, {
    icon: Clock,
    text: 'Reset de 12 minutos (protocolo base)'
  }, {
    icon: Thermometer,
    text: 'Protocolos por escenario (calor, mente, hambre)'
  }, {
    icon: CheckSquare,
    text: "Checklist 'Dormitorio 3AM' (ajustes sin gastar fortuna)"
  }, {
    icon: Moon,
    text: 'Rutina pre-sueño de 18 minutos (mínima, real)'
  }, {
    icon: ListChecks,
    text: 'Tracker de 14 noches para medir progreso'
  }];
  // Map icon component needed since I used Map in the array but didn't import it in the array definition properly
  // Let's fix the icon import above first
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-cream" data-id="element-177">
      <div className="max-w-4xl mx-auto" data-id="element-178">
        <div className="text-center mb-12" data-id="element-179">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 font-serif text-navy" data-id="element-180">
            Qué incluye el Kit
          </h2>
          <p className="text-lg text-gray-600" data-id="element-181">
            Todo lo que necesitás para dejar de improvisar a la madrugada.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl p-8 sm:p-12 border border-gray-100" data-id="element-182">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-12" data-id="element-183">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start" data-id="element-184">
                <div className="flex-shrink-0 mt-1" data-id="element-185">
                  <div className="w-8 h-8 rounded-full bg-purple/10 flex items-center justify-center text-purple" data-id="element-186">
                    <item.icon className="w-4 h-4" data-id="element-187" />
                  </div>
                </div>
                <span className="ml-4 text-gray-700 font-medium text-lg" data-id="element-188">
                  {item.text}
                </span>
              </motion.div>)}
          </div>

          <div className="mt-12 p-6 bg-navy/5 rounded-xl border border-navy/10 text-center" data-id="element-189">
            <p className="text-navy font-serif italic text-lg" data-id="element-190">
              "Volver a dormir no es fuerza de voluntad: es diseño."
            </p>
          </div>
        </div>
      </div>
    </section>;
}
// Helper for the missing icon import
import { Map } from 'lucide-react';